//================================================================================
// 29th Oct, 2025 src/components/tenantcomponents/LegalAgreements/UserAgreement.js
//================================================================================
import React from 'react';
import { Typography, Box, List, ListItem } from '@mui/material';

const UserAgreement = () => (
  <Box sx={{ maxHeight: '400px', overflow: 'auto', p: 2, border: '1px solid #ccc', mb: 2 }}>
    <Typography variant="h6" gutterBottom>
      USER RESPONSIBILITY AGREEMENT
    </Typography>

    <Typography variant="body2" paragraph>
      As a user of MedicERP’s pharmacy management system you agree to:
      <List>
        <ListItem>- Maintain accurate medication, inventory and financial records in accordance with your firm’s recordkeeping policies and internal controls.</ListItem>
        <ListItem>- Under no circumstances use MedicERP in a manner that violates the law of the land; you must ensure all activity and records comply with applicable local, state and national laws.</ListItem>
        <ListItem>- Verify prescription validity before dispensing any medication; MedicERP is not responsible for dispensing errors.</ListItem>
        <ListItem>- Maintain patient confidentiality and ensure secure handling of patient information consistent with applicable privacy and healthcare regulations.</ListItem>
        <ListItem>- Comply with all applicable drug-control laws, GST rules and other regulations applicable to your business.</ListItem>
        <ListItem>- Report system discrepancies to MedicERP promptly and retain audit trails for all transactions as required by your firm’s policies and applicable law.</ListItem>
        <ListItem>- Keep login credentials secure and do not share them with unauthorized personnel; you are responsible for actions taken under your accounts.</ListItem>
        <ListItem>- Maintain independent backups of your data on a regular basis; do not rely solely on MedicERP for backups during the beta/free period.</ListItem>
      </List>
    </Typography>

    <Typography variant="body2" paragraph>
      <strong>Disclaimer:</strong> The system owner and software provider (MedicERP) are not liable for regulatory compliance failures, incorrect data entry by users, or breaches caused by user negligence or misuse. MedicERP is not responsible for data breaches resulting from the user’s failure to secure credentials, devices, or internal systems.
    </Typography>

    <Typography variant="body2" paragraph>
      <strong>Governing law:</strong> Where applicable to these user responsibilities, compliance obligations are governed by the law of the land (the laws of India). Disputes arising from this Agreement shall be subject to the governing law and jurisdiction specified in the Master Services Agreement.
    </Typography>
  </Box>
);

export default UserAgreement;
